import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { Counts } from '../../_models/data';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';
import { IdentityDocumentData } from '../../_models/identityDocuments';

@Component({
  selector: 'app-identity-document',
  templateUrl: './identity-document.component.html',
  styleUrl: './identity-document.component.css'
})

export class IdentityDocumentComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  
  // userData: UserData;
  page: number = 1;
  count: Counts;

  url = this.router.url.slice(1);

  mainHeader: string = "List All Identity Documents";
  formHeader: string = "Add New Identity Document";
  view: string = "";

  processing: boolean = false;
  loading: boolean = true;
  buttonText: string = "Add New Identity Document";

  identityList: IdentityDocumentData[] = [];

  edit: boolean = false;
  identityName: string = '';
  identityRef: number = 0;

  dataForm = this.fb.group({
    ref: [0],
    title: ["", Validators.required],
  }, {});
  
  get ref() { return this.dataForm.get('ref'); }
  get title() { return this.dataForm.get('title'); }

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.checkService.checkSession();
    this.getRouteParams();
  }

  ngOnInit(): void {

    if (this.routeParams['view'] !== undefined) {
      this.view = this.routeParams['view'];
      this.mainHeader = "List "+this.view+" Identity Documents";
    }

    if (this.queryParams['page'] !== undefined) {
      this.page = this.queryParams['page'];
    } else {
      this.page = 1;
    }
    this.getIDs(this.page);
  }

  getIDs(page:number) {
    this.loading = true;

    this.apiService.getIDs(page, this.view).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.count = data.counts;
          this.identityList = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }

  onCreate() {
    var data: object = {
      title: this.dataForm.value.title
    };
    if (this.edit === true) {
      data['ref'] = this.dataForm.value.ref;
      this.editID(data);
    } else {
      data['online'] = 0;
      this.createID(data);
    }
  }

  createID( data ) {
    this.processing = true;

    this.buttonText = "Adding New Identity Document...";
    this.apiService.createID(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Created "+data.title+" as a identity document", "Identity Document Created");
          this.checkService.closeModal('modal-identity-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Identity Document";
      }
    );
  }

  editID( data ) {
    this.processing = true;

    this.buttonText = "Saving Changes...";
    this.apiService.editID(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("saved changes made to identity document", "Identity Document Edited");
          this.checkService.closeModal('modal-identity-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Identity Document";
        this.edit = false;
      }
    );
  }

  getEdit(data:IdentityDocumentData) {
    this.dataForm.patchValue({
      ref: data.ref,
      title: data.title
    });
    this.edit = true;
    this.formHeader = "Edit "+data.title;
    this.buttonText = "Edit Identity Document";
  }

  onCancel() {
    this.edit = false;
    this.dataForm.reset();
    this.formHeader = this.buttonText = "Add New Identity Document";
  }
  
  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }

  changeIDStatus(action:string, ref:number) {
    let data:Object = {
      ref: ref,
      status: action.toLowerCase()
    }

    this.processing = true;

    this.apiService.changeIDStatus(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Changes made to Identity Document successfully", "Identity Document Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-online').click();
        document.getElementById('modal-offline').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  changeIDVisibility(action:string, ref:number) {
    let data:Object = {
      ref: ref,
      status: action.toLowerCase()
    }

    this.processing = true;

    this.apiService.changeIDVisibility(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Changes made to Identity Document successfully", "Identity Document Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-online').click();
        document.getElementById('modal-offline').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  deleteID(ref:number) {
    this.processing = true;

    this.apiService.deleteID(ref).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Identity Document Removed Successfully", "Identity Document Deleted");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-online').click();
        document.getElementById('modal-offline').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  getDataFromList(name:string, ref:number) {
    this.identityName = name;
    this.identityRef = ref;
  }
}
